function getQueryParams() {
    const params = {};
    const queryString = window.location.search.slice(1);
    queryString.split('&').forEach(param => {
        const [key, value] = param.split('=');
        params[key] = decodeURIComponent(value);
    });
    return params;
}

function getMockedDate() {
    const params = getQueryParams();
    return params.mockDate ? new Date(params.mockDate) : null;
}

function getMockedLocation() {
    const params = getQueryParams();
    if (params.mockLocation) {
        switch (params.mockLocation.toUpperCase()) {
            case 'ISRAEL':
                return {
                    latitude: 31.7683, // Jerusalem, Israel
                    longitude: 35.2137,
                    timezone: 'Asia/Jerusalem',
                    isIsrael: true
                };
            case 'NY':
                return {
                    latitude: 40.7128, // New York City, USA
                    longitude: -74.0060,
                    timezone: 'America/New_York',
                    isIsrael: false
                };
            case 'LONDON':
                return {
                    latitude: 51.5074, // London, UK
                    longitude: -0.1278,
                    timezone: 'Europe/London',
                    isIsrael: false
                };
            default:
                return null;
        }
    }
    return null;
}

function shouldCheckGeolocation(now) {
    const dayOfWeek = now.getDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6
    const month = now.getMonth() + 1; // Months are 0-indexed, so add 1

    const isShabbat = (dayOfWeek === 5 || dayOfWeek === 6); // Friday or Saturday
    const isHolidayMonth = (month === 3 || month === 4 || month === 5 || month === 6 || month === 9 || month === 10); // March-April-May-June-September-October

    return isShabbat || isHolidayMonth;
}

async function fetchGeolocation() {
    const apiKey = '918995e101b14756bc9b4bf5897bd534';
    const apiUrl = `https://api.ipgeolocation.io/ipgeo?apiKey=${apiKey}`;

    try {
        const response = await fetch(apiUrl);
        const data = await response.json();

        const latitude = data.latitude;
        const longitude = data.longitude;
        const timezone = data.time_zone.name
        const isIsrael = data.country_name === "Israel";

        return { latitude, longitude, timezone, isIsrael };
    } catch (error) {
        console.error("Error fetching geolocation data:", error);
        return null;
    }
}

async function fetchHebcalData(now, latitude, longitude, tzid, isIsrael) {
    const startDate = new Date(now);
    // Really 3 should be OK, but we do 5 to be safe
    startDate.setDate(now.getDate() - 5);
    const endDate = new Date(now);
    endDate.setDate(now.getDate() + 5);

    const startStr = startDate.toISOString().split('T')[0]; // Convert to YYYY-MM-DD format
    const endStr = endDate.toISOString().split('T')[0];

    let apiUrl = `https://www.hebcal.com/hebcal?v=1&cfg=json&maj=on&c=on&M=on&leyning=off&geo=pos&latitude=${latitude}&longitude=${longitude}&tzid=${tzid}&start=${startStr}&end=${endStr}`;

    if (isIsrael) {
        apiUrl += '&i=on';
    }

    try {
        const response = await fetch(apiUrl);
        const data = await response.json();
        return data.items.filter(item => item.category === 'candles' || item.category === 'havdalah');
    } catch (error) {
        console.error("Error fetching HebCal data:", error);
        return null;
    }
}

function isMelachaForbiddenNow(now, items) {
    const nowTime = now.getTime();

    // Find the closest candles entry before the current time
    let closestCandles = null;
    for (const item of items) {
        if (item.category === 'candles') {
            const candlesTime = new Date(item.date).getTime();
            if (candlesTime <= nowTime) {
                closestCandles = candlesTime;
            } else {
                break; // We've passed the current time, stop checking further
            }
        }
    }

    // If no candles entry was found, we're not in a melacha forbidden period
    if (!closestCandles) {
        return false;
    }

    // Find the closest havdalah entry between the closest candles entry and now
    for (const item of items) {
        if (item.category === 'havdalah') {
            const havdalahTime = new Date(item.date).getTime();
            if (havdalahTime >= closestCandles && havdalahTime <= now) {
                return false; // Found havdalah entry within the period, melacha is permitted now
            }
        }
    }

    // If no havdalah entry was found, we're still in a melacha-forbidden period
    return true;
}

function isShabbatPage() {
    const shabbatPage = 'https://' + window.location.hostname + '/pages/shabbat';
    const currentPage = window.location.href.split('?')[0].replace(/\/$/, '');
    return currentPage === shabbatPage;
}

function redirectToHomePage() {
    const homePage = 'https://' + window.location.hostname;
    const params = new URLSearchParams(window.location.search);

    // Append mockDate and mockLocation to the redirection URL if they exist
    const mockDate = params.get('mockDate');
    const mockLocation = params.get('mockLocation');

    let url = homePage;

    if (mockDate || mockLocation) {
        const redirectParams = new URLSearchParams();
        if (mockDate) redirectParams.set('mockDate', mockDate);
        if (mockLocation) redirectParams.set('mockLocation', mockLocation);
        url += '?' + redirectParams.toString();
    }

    window.location.href = url;
}

function redirectToShabbatPage() {
    const shabbatPage = 'https://' + window.location.hostname + '/pages/shabbat';

    const params = new URLSearchParams(window.location.search);

    // Append mockDate and mockLocation to the redirection URL if they exist
    const mockDate = params.get('mockDate');
    const mockLocation = params.get('mockLocation');

    let url = shabbatPage;

    if (mockDate || mockLocation) {
        const redirectParams = new URLSearchParams();
        if (mockDate) redirectParams.set('mockDate', mockDate);
        if (mockLocation) redirectParams.set('mockLocation', mockLocation);
        url += '?' + redirectParams.toString();
    }

    window.location.href = url;
}

function getNextHavdalahTime(now, items) {
    const nowTime = now.getTime();

    for (const item of items) {
        if (item.category === 'havdalah') {
            const havdalahTime = new Date(item.date).getTime();
            if (havdalahTime > nowTime) {
                return havdalahTime;
            }
        }
    }

    return null; // No upcoming havdalah found
}

let timerStartTime = null;
let initialMockedTime = null;

function handleTimer(nextHavdalahTime) {
    const timerElement = document.getElementById('timer');

    if (!timerElement || !nextHavdalahTime) {
        return; // No timer element or havdalah time, do nothing
    }

    const countdown = setInterval(function() {
        const nowRealTime = new Date().getTime(); // Get the real current time
        const mockedDate = getMockedDate();

        if (!timerStartTime && mockedDate) {
            timerStartTime = nowRealTime; // Store the real start time when the function first runs
            initialMockedTime = mockedDate.getTime(); // Store the mocked start time
        }

        // Calculate the 'nowTime' based on the real time passed and the mocked start time
        let nowTime;
        if (initialMockedTime) {
            // Add the time difference between real time and when the timer started to the mocked start time
            const elapsedTime = nowRealTime - timerStartTime;
            nowTime = initialMockedTime + elapsedTime;
        } else {
            nowTime = nowRealTime;
        }

        const distance = nextHavdalahTime - nowTime;

        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Ensure no negative values by setting them to 0 when countdown is over
        if (distance < 0) {
            days = hours = minutes = seconds = 0;
        }

        timerElement.innerHTML = days + "d " + hours + "h " + minutes + "m " + seconds + "s ";

        // If the countdown is over, redirect to the home page
        if (distance < 0) {
            clearInterval(countdown);
            redirectToHomePage();
        }
    }, 1000);
}

// Main execution logic wrapped in a function
async function handleShabbatAndYomTov() {
    // ?mockDate=2024-09-27T18:00:00&mockLocation=Israel
    // When mocking location you need to change system timezone too
    // System Preferences > Date & Time

    // Check if we are currently in the theme editor (I added typeof Shopify !== 'undefined' &&)
    // The old code had this I think to prevent redirecting away from Shabbat page while in editor mode
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        return;
    }

    // Check if we are currently in an iFrame (old code had this)
    // The old code had this, but I'm not sure why
    if (self !== top) {
        return;
    }

    const now = getMockedDate() || new Date();

    if (!shouldCheckGeolocation(now)) {
        return;
    }

    const geoData = getMockedLocation() || await fetchGeolocation();

    if (!geoData) {
        return;
    }

    const hebcalItems = await fetchHebcalData(now, geoData.latitude, geoData.longitude, geoData.timezone, geoData.isIsrael);

    if (!hebcalItems) {
        return;
    }

    const isMelachaForbidden = isMelachaForbiddenNow(now, hebcalItems);

    if (isMelachaForbidden && !isShabbatPage()) {
        // Redirect to Shabbat page
        redirectToShabbatPage();
    } else if (!isMelachaForbidden && isShabbatPage()) {
        // Redirect to home page if melacha is no longer forbidden
        redirectToHomePage();
    }

    // If we are on the Shabbat page, start the countdown timer
    if (isShabbatPage() && isMelachaForbidden) {
        const nextHavdalahTime = getNextHavdalahTime(now, hebcalItems);
        handleTimer(nextHavdalahTime);
    }
}

async function handleForcedShutdown() {
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        return;
    }

    if (self !== top) {
        return;
    }

    // Uncomment this to bypass the forced shutdown, then add ?sg_dev_bypass_928174=1 to the URL when visiting for the first time and it will be stored in session
    // const params = new URLSearchParams(window.location.search);
    // const BYPASS_KEY = "sg_dev_bypass_928174";
    // if (params.get(BYPASS_KEY) === "1") {
    //     sessionStorage.setItem(BYPASS_KEY, "1");
    // }
    // const bypassEnabled = sessionStorage.getItem(BYPASS_KEY) === "1";

    // if (bypassEnabled) {
    //     return;
    // }

    // Set the shutdown end time in UTC (example: midnight New York time)
    // You can modify this value as needed
    const shutdownUntilTime = new Date('2026-09-27T01:30:00Z');
    
    // Get current time
    const now = new Date();
    const isDuringForcedShutdown = now < shutdownUntilTime;
    
    if (isDuringForcedShutdown && !isShabbatPage()) {
        redirectToShabbatPage();
    } else if (!isDuringForcedShutdown && isShabbatPage()) {
        redirectToHomePage();
    }

    // If we are on the Shabbat page, start the countdown timer
    if (isShabbatPage() && isDuringForcedShutdown) {
        
        // Add a 1 second delay to ensure DOM is loaded which does not seem to be an issue in handleShabbatAndYomTov presumably because we are making some API calls there
        setTimeout(() => {
            handleTimer(shutdownUntilTime.getTime());
        }, 1000);
    }
}

handleShabbatAndYomTov().then();

// Uncomment to do a forced shutdown (e.g. some launch unrelated to Shabbat/YomTov), make sure to change the date in the code. Make sure to comment handleShabbatAndYomTov().then(); directly above this!!!
// handleForcedShutdown().then();